// extracted by mini-css-extract-plugin
export var cancelButton = "_mh-5";
export var content = "_mh-3";
export var createButton = "_mh-6";
export var drawerContainer = "_mh-0";
export var footer = "_mh-2";
export var header = "_mh-1";
export var orderFormColumn = "_mh-4";